// extracted by mini-css-extract-plugin
module.exports = {"st0":"WarningIcon_st0__2Ls9G","st1":"WarningIcon_st1__3EbXp","st2":"WarningIcon_st2__2Q6d9","st3":"WarningIcon_st3__2eHDu","st4":"WarningIcon_st4__2A_h2"};